/**
 * Validates Phone Number
 * @param {string} phoneNumber
 * @returns {boolean}
 */
export default function isPhoneNumbersValid(phoneNumber) {
  const phoneNumberRegexp = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im

  return phoneNumberRegexp.test(phoneNumber)
}
